import { render } from "./QuestInfoPage.vue?vue&type=template&id=6b0cf8c9&scoped=true"
import script from "./QuestInfoPage.vue?vue&type=script&lang=js"
export * from "./QuestInfoPage.vue?vue&type=script&lang=js"

import "./QuestInfoPage.vue?vue&type=style&index=0&id=6b0cf8c9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0cf8c9"]])

export default __exports__